import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

interface SendFeedbackBody {
  answer: string
  subAnswer: string
}

const sendFeedbackApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    sendFeedback: builder.mutation<void, SendFeedbackBody>({
      query: (data) => ({
        url: `${APP.TIKTOK_SERVER}/artist/survey-responses`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
})
export const { useSendFeedbackMutation } = sendFeedbackApi
